<div class="alertCenterList">
    <alert-center-item *ngFor="let a of alertCenterList" [alert]="a"></alert-center-item>
</div>
